import Generic from "../Generic";

export default Object.assign({}, Generic, {
  background: require("./images/global_bkg.jpg"),
  ipg_background: require("./images/ipg_bkg.jpg"),
  menu_background: require("./images/main_bkg.jpg"),
  welcome_background: require("./images/PromoCh_bkg.jpg"),
});
